<!-- Filters Section -->
<div class="row ms-0 me-0 mt-1 mb-1">
    <div class="col-md-1 ps-1 pe-1 d-flex align-items-end">
        <span>Filter By: </span>
    </div>
    <div class="col-md-2 ps-1 pe-1 d-flex align-items-end">
        <rb-form-multi-select
            name="multiSelect1"
            idField="id"
            labelField="label"
            [items]="vehicleBrandOptions"
            [(ngModel)]="selectedVehicleBrandOptions"
            (ngModelChange)="getVehiclesFiltered()"
            [disabled]="vehicleBrandOptions.length === 0"
            label="Vehicle Brand"
            style="width: 100%">
            <span *rbFormMultiSelectOption="let item">{{ item.label }}</span>
        </rb-form-multi-select>
    </div>
    <div class="col-md-2 ps-1 pe-1 d-flex align-items-end">
        <rb-form-multi-select
            name="multiSelect2"
            idField="id"
            labelField="label"
            [items]="vehicleTypeOptions"
            [(ngModel)]="selectedVehicleTypeOptions"
            (ngModelChange)="getVehiclesFiltered()"
            [disabled]="vehicleTypeOptions.length === 0"
            label="Vehicle Type"
            style="width: 100%">
            <span *rbFormMultiSelectOption="let item">{{ item.label }}</span>
        </rb-form-multi-select>
    </div>
    <div class="col-md-2 ps-1 pe-1 d-flex align-items-end">
        <rb-form-multi-select
            name="multiSelect3"
            idField="id"
            labelField="label"
            [items]="productionYearOptions"
            [(ngModel)]="selectedProductionYearOptions"
            (ngModelChange)="getVehiclesFiltered()"
            [disabled]="productionYearOptions.length === 0"
            label="Vehicle Year"
            style="width: 100%">
            <span *rbFormMultiSelectOption="let item">{{ item.label }}</span>
        </rb-form-multi-select>
    </div>
    <div class="col-md-2 ps-1 pe-1 d-flex align-items-end">
        
    </div>
    <div class="col-md-3 ps-1 pe-1 d-flex justify-content-end align-items-end">
        <button type="button" class="rb-btn rb-primary" (click)="goTo('onboarding')">
            <span class="rb-ic rb-ic-car-connected"></span>
            &nbsp; Add new vehicles
        </button>
    </div>
</div>
<hr>
<div class="row ms-0 me-0 mt-1 mb-1">
    <div class="col-md-2 ps-1 pe-1 d-flex align-items-end">
        <rb-form-input class="rb-input" placeholder="Search vehicles..." [(ngModel)]="searchQuery" (input)="applySearchAndFilters()" style="width:100%" />
    </div>
    <div class="col-md-10 ps-1 pe-1 d-flex justify-content-end align-items-end">
        <button type="button" class="rb-btn rb-primary" (click)="downloadTablePdfReport()" [disabled]="displayVehicles.length === 0">
                <span class="rb-ic rb-ic-download"></span>
                &nbsp; Download PDF report
        </button>
    </div>
<hr>
<!-- Switch View Buttons -->
<div class="row ms-0 me-0 mt-1 mb-1">
    <div class="col-6 d-flex justify-content-start align-items-center">
        <span>View Mode:</span>
        <button title="Card View" class="rb-btn rb-link" (click)="goToCardView()" [ngStyle]="cardView ? {'border-bottom': '2px solid #007BC0', 'padding-bottom': '0.25rem'} : {'padding-bottom': '0.25rem'}">
            <span class="rb-ic rb-ic-grid-view"></span>
        </button>
        <button title="Table View" class="rb-btn rb-link" (click)="goToListView()" [ngStyle]="listView ? {'border-bottom': '2px solid #007BC0', 'padding-bottom': '0.25rem'} : {'padding-bottom': '0.25rem'}">
            <span class="rb-ic rb-ic-list-view"></span>
        </button>
    </div>
    <div class="col-6 d-flex justify-content-end align-items-center">
        <button
            type="button"
            class="rb-btn"
            [rbPopover]="legendPopover"
            [position]="'left'"
            [renderOnInit]="true">
            <span class="rb-ic rb-ic-list-view-mobile"></span>
            &nbsp;Legend
        </button>
        <ng-template #legendPopover let-close="close">
            <button title="Outdated" class="rb-btn rb-tiny status-icon-btn-legend">
                <span class="rb-ic rb-ic-clock"></span>
            </button>&nbsp;<span>Results: Outdated</span>&nbsp;
        </ng-template>
    </div>
</div>

<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>

<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No vehicles found! 
        <br />
        <span *ngIf="selectedVehicleBrandOptions?.length > 0 || selectedVehicleTypeOptions?.length > 0 || selectedProductionYearOptions?.length > 0">Change filters.</span>
    </rb-callout>
</div>

<!-- Card View -->
<div class="row ms-0 me-0" *ngIf="cardView && !dataLoading && !errorMessage">
    <div *ngFor="let vehicle of displayVehicles" class="col-md-4 ms-0 me-0 p-1 d-flex"> <!-- ps-1 pe-1 -->
        <div class="shaded-container mb-2 p-1 d-flex flex-column flex-fill h-100" style="position: relative;">
            <ng-container *ngIf="vehicle.resultStatus === 'outdated'">
                <button title="Outdated" type="button" class="rb-btn rb-tiny status-icon-btn" [rbTooltip]="'Last datapoint: ' + (vehicle.timestamp ? (vehicle.timestamp | date:'dd MMM yyyy') : 'N/A')">
                    <span class="rb-ic rb-ic-clock"></span>
                </button>
            </ng-container>
            <!-- TODO: Enable result reasons tooltip -->
            <!-- <ng-template let-close="close" let-fixed="fixed" #resultReasons>
                <div class="p-1">
                    <button type="button" class="rb-btn rb-tiny" (click)="close()" *ngIf="fixed">
                        <span class="rb-ic rb-ic-close"></span>
                    </button>
                    <div *ngFor="let reason of vehicle.resultReasons">
                        <span>
                            {{ reason }}
                        </span>
                        <br/>
                    </div>
                </div>
            </ng-template> -->
            <div class="row d-flex align-items-center justify-content-center flex-grow-1 m-0">
                <div class="col-6 ms-0 me-0 ps-1 pe-0 d-flex justify-content-center vehicle-image-container">
                    <img [src]="vehicle.urlImage" [alt]="vehicle.vehicleBrand || 'Vehicle'" title="Vehicle image" class="vehicle-image">
                </div>
                <div class="col-6 ms-0 me-0 ps-0 pe-1">
                    <p><strong style="font-size: 1.25rem;">{{ vehicle.name ? vehicle.name : 'N/A' }}</strong></p>
                    <p class="mt-1 mb-1"><strong>Manufacturer:</strong> {{ vehicle.vehicleBrand ? vehicle.vehicleBrand : 'N/A' }}</p>
                    <p class="mt-1 mb-1"><strong>Model:</strong> {{ vehicle.vehicleModel ? vehicle.vehicleModel : 'N/A' }}</p>
                    <p class="mt-1 mb-1" *ngIf="vehicle.dataAvailable"><strong>Mileage:</strong> {{ getFormattedMileage(vehicle.mileage) }}</p>
                </div>
                <hr>
            </div>
            <div class="row d-flex align-items-center flex-grow-1 m-0" *ngIf="vehicle.dataAvailable && (vehicle.predictedReqDistance === null || vehicle.predictedReqDistance === 0 || vehicle.batteryStateOfHealth !== null && vehicle.batteryStateOfHealth !== undefined)">
                <div class="col-6 ms-0 me-0 ps-1 pe-0">
                    <p class="mt-1 mb-1"><strong rbTooltip="Battery State of Health">SoH:</strong> {{ vehicle.batteryStateOfHealth ? (vehicle.batteryStateOfHealth | removeDecimalPoints:0) + '%' : 'N/A' }}</p>
                    <p class="mt-1 mb-1"><strong rbTooltip="Prediction of Battery State of Health">SoH {{vehicle.predictionDays ? (vehicle.predictionDays | inTime:false) : 'in 1 year'}}:</strong> {{ vehicle.predSohc ? (vehicle.predSohc | removeDecimalPoints:0) + '%' : 'N/A' }}</p>
                </div>
                <div class="col-6 ms-0 me-0 ps-0 pe-1">
                    <p class="mt-1 mb-1"><strong>Current Energy:</strong> {{ vehicle.usableCurrEnergy ? (vehicle.usableCurrEnergy | whToKwh | removeDecimalPoints:0) + ' kWh' : 'N/A' }}</p>
                    <p class="mt-1 mb-1"><strong>Initial Energy:</strong> {{ vehicle.usableInitialEnergy ? (vehicle.usableInitialEnergy | whToKwh | removeDecimalPoints:0) + ' kWh' : 'N/A' }}</p>
                </div>
                <hr>
            </div>
            <div class="row d-flex align-items-center flex-grow-1 m-0" *ngIf="vehicle.dataAvailable && (vehicle.predictedReqDistance === null || vehicle.predictedReqDistance === 0 || vehicle.batteryStateOfHealth !== null && vehicle.batteryStateOfHealth !== undefined)">
                <div class="col-6 ms-0 me-0 ps-1 pe-0">
                    <p class="mt-1 mb-1"><strong>Avg. Efficiency:</strong> {{ getFormattedAvgEfficiency(vehicle.avgEvEfficiency) }}</p>
                </div>
                <div class="col-6 ms-0 me-0 ps-0 pe-1">
                    <p class="mt-1 mb-1"><strong>Range from Efficiency:</strong> {{ getFormattedMileage(vehicle.currRange) }}</p>
                </div>
                <hr class="mb-0">
            </div>
            <div class="row d-flex align-items-center flex-grow-1 m-0" *ngIf="!vehicle.dataAvailable || (vehicle.predictedReqDistance !== null && vehicle.predictedReqDistance !== 0 && (vehicle.batteryStateOfHealth === null || vehicle.batteryStateOfHealth === undefined))">
                <div class="col-12 ms-0 me-0 ps-1 pe-0">
                    <p class="mt-1 mb-1">
                        This vehicle is in the onboarding phase. We need to collect more data to generate insights. 
                        <span *ngIf="vehicle.predictedReqDistance !== null && vehicle.predictedReqDistance !== 0 && (vehicle.batteryStateOfHealth === null || vehicle.batteryStateOfHealth === undefined)">Approximately <strong>{{ getFormattedMileage(vehicle.predictedReqDistance) }}</strong> more are needed.</span>
                    </p>
                </div>
                <hr class="mb-0">
            </div>
            <div class="row d-flex align-items-center m-0" style="background-color: var(--bosch-gray-80); margin-top: auto">
                <div class="col-7 ms-0 me-0 ps-1 pe-1 d-flex justify-content-center">
                    <p class="mt-1 mb-1 text-center"><strong class="text-center" [ngStyle]="{
                        'color': vehicle.agingClass === 'average' ? 'var(--bosch-blue-50)' : 
                                vehicle.agingClass === 'above average' ? 'var(--bosch-green-50)' : 
                                vehicle.agingClass === 'below average' ? 'var(--bosch-purple-50)' :
                                'var(--bosch-black)'
                    }"> {{ ((vehicle.agingClass !== '' && vehicle.agingClass != null ) && vehicle.dataAvailable) ? vehicle.agingClass + ' condition' : '' }} </strong></p> 
                </div>
                <div class="col-4 ms-0 me-0 ps-0 pe-0 d-flex justify-content-center">
                    <button title="Insights" type="button" class="rb-btn rb-primary" style="width: 100%; padding: 0; border: 1px solid var(--bosch-gray-80);" (click)="goToInsights(vehicle.batteryIdentifier)" [disabled]="!vehicle.dataAvailable">
                        <span class="rb-ic rb-ic-compare"></span>
                        &nbsp; EV Insights
                    </button>
                </div>
                <div class="col-1 ms-0 me-0 ps-0 pe-0 d-flex justify-content-center align-self-end">
                    <button *ngIf="vehicle?.certificateStatus && vehicle?.certificateStatus?.generatedCertificate > 0, else noCertificate" title="Certificate" type="button" class="rb-btn rb-primary" style="width: 100%; padding: 0; border: 1px solid var(--bosch-gray-80);" 
                    (click)="openDialog(demoDialog, vehicle.batteryIdentifier)">
                        <span class="rb-ic rb-ic-badge-checkmark"></span>
                    </button>
                    <ng-template #noCertificate>
                        <button title="Certificate" type="button" class="rb-btn rb-primary" style="width: 100%; padding: 0; border: 1px solid var(--bosch-gray-80);" disabled>
                            <span class="rb-ic rb-ic-badge-checkmark"></span>
                        </button>
                    </ng-template>
                </div>
                <ng-template #demoDialog>
                    <rb-dialog
                        dialogTitle="Download Battery Certificate"
                        [confirmationButtonLabel]="buttonLabels.confirmLabel"
                        [cancelButtonLabel]="buttonLabels.cancelLabel">
                        Your battery certificate is ready for download. Click 'Download' to save the file.
                    </rb-dialog>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="row d-flex align-items-center justify-content-center m-0" *ngIf="displayVehicles.length > 0">
        <rb-pagination [pageData]="pageData" (navigate)="navigateCall($event)"></rb-pagination>
    </div>
</div>

<!-- Table View -->
<div class="row ms-0 me-0" *ngIf="listView && !dataLoading && !errorMessage">
    <div class="col-12" *ngIf="displayVehicles.length > 0">
        <table class="m-table" *rbTable="loader; fixedHeaderWidth: false; columns: 12" [rbSort]="{id: '', direction: ''}" (rbSortChange)="onSortChange($event)">
            <thead>
                <tr>
                    <th rb-sort-header="name" [disableSortClear]="true">Asset Name</th>
                    <th rb-sort-header="vehicleBrand" [disableSortClear]="true">Vehicle Brand</th>
                    <th rb-sort-header="vehicleModel" [disableSortClear]="true">Vehicle Model</th>
                    <th rb-sort-header="mileage" [disableSortClear]="true">Mileage</th>
                    <th rb-sort-header="batteryStateOfHealth" [disableSortClear]="true">State of Health</th>
                    <th rb-sort-header="predSohc" [disableSortClear]="true">Predicted State of Health</th>
                    <th rb-sort-header="currRange" [disableSortClear]="true">Range from Efficiency</th>
                    <th rb-sort-header="predRange" [disableSortClear]="true">Predicted Range from Efficiency</th>
                    <th rb-sort-header="usableCurrEnergy" [disableSortClear]="true">Current Energy</th>
                    <th rb-sort-header="usableInitialEnergy" [disableSortClear]="true">Initial Energy</th>
                    <th rb-sort-header="avgEvEfficiency" [disableSortClear]="true">Avg. Efficiency</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let vehicle of displayVehicles; let i = index">
                    <tr *ngIf="vehicle.dataAvailable && (vehicle.predictedReqDistance === null || vehicle.predictedReqDistance === 0 || vehicle.batteryStateOfHealth !== null && vehicle.batteryStateOfHealth !== undefined)">
                        <td>{{ vehicle.name ? vehicle.name : 'N/A' }}</td>
                        <td>{{ vehicle.vehicleBrand ? vehicle.vehicleBrand : 'N/A' }}</td>
                        <td>{{ vehicle.vehicleModel ? vehicle.vehicleModel : 'N/A' }}</td>
                        <td class="no-wrap-cell">{{ getFormattedMileage(vehicle.mileage) }}</td>
                        <td class="no-wrap-cell">{{ vehicle.batteryStateOfHealth ? (vehicle.batteryStateOfHealth | removeDecimalPoints:0) + '%' : 'N/A' }}</td>
                        <td class="no-wrap-cell">{{ vehicle.predSohc ? (vehicle.predSohc | removeDecimalPoints:0) + '% (' + (vehicle.predictionDays|inTime:false) + ')': 'N/A' }}</td>
                        <td class="no-wrap-cell">{{ getFormattedMileage(vehicle.currRange) }}</td>
                        <td class="no-wrap-cell">{{ getFormattedPredRange(vehicle.predRange, vehicle.predictionDays) }}</td>
                        <td class="no-wrap-cell">{{ vehicle.usableCurrEnergy ? (vehicle.usableCurrEnergy | whToKwh | removeDecimalPoints:0) + ' kWh' : 'N/A' }}</td>
                        <td class="no-wrap-cell">{{ vehicle.usableInitialEnergy ? (vehicle.usableInitialEnergy | whToKwh | removeDecimalPoints:0) + ' kWh' : 'N/A' }}</td>
                        <td class="no-wrap-cell">{{ getFormattedAvgEfficiency(vehicle.avgEvEfficiency) }}</td>
                        <td>
                            <button title="Insights" class="rb-btn" (click)="goToInsights(vehicle.batteryIdentifier)">
                                <span class="rb-ic rb-ic-chart-bar"></span>
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="!vehicle.dataAvailable || (vehicle.predictedReqDistance !== null && vehicle.predictedReqDistance !== 0 && (vehicle.batteryStateOfHealth === null || vehicle.batteryStateOfHealth === undefined))">
                        <td>{{ vehicle.name ? vehicle.name : 'N/A' }}</td>
                        <td>{{ vehicle.vehicleBrand ? vehicle.vehicleBrand : 'N/A' }}</td>
                        <td>{{ vehicle.vehicleModel ? vehicle.vehicleModel : 'N/A' }}</td>
                        <td colspan="8">
                            <p class="onboarding-phase-text">
                                This vehicle is in the onboarding phase. We need to collect more data to generate insights.
                                <span *ngIf="vehicle.predictedReqDistance !== null && vehicle.predictedReqDistance !== 0 && (vehicle.batteryStateOfHealth === null || vehicle.batteryStateOfHealth === undefined)">Approximately <strong>{{ getFormattedMileage(vehicle.predictedReqDistance) }}</strong>  more are needed.</span>
                            </p>
                        </td>
                        <td>
                            <button title="Insights" class="rb-btn" disabled>
                                <span class="rb-ic rb-ic-chart-bar"></span>
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <div class="row d-flex align-items-center justify-content-center m-0 mt-2">
            <rb-pagination [pageData]="pageData" (navigate)="navigateCall($event)"></rb-pagination>
        </div>
    </div>
</div>